import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { User, Lock, LogIn } from 'lucide-react';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.username, formData.password);
    
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="page">
      <div className="form-container">
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <LogIn size={48} style={{ color: '#3498db', marginBottom: '1rem' }} />
          <h1>Sign In</h1>
          <p style={{ color: '#7f8c8d' }}>Welcome back to QuizCanvas</p>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username"> 
              <User size={16} style={{ display: 'inline', marginRight: '0.5rem' }} />
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username" 
              value={formData.username} 
              onChange={handleChange}
              required
              placeholder="Enter your username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <Lock size={16} style={{ display: 'inline', marginRight: '0.5rem' }} />
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-full-width"
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <p style={{ color: '#7f8c8d', marginBottom: '1rem' }}>
            Don't have an account?{' '}
            <Link to="/register" style={{ color: '#3498db', textDecoration: 'none' }}>
              Create one here
            </Link>
          </p>
          
          <div style={{ marginBottom: '10px' }}>
            <Link 
              to="/forgot-password" 
              style={{ color: '#3498db', textDecoration: 'none', fontSize: '0.9rem' }}
            >
              Forgot your password?
            </Link>
          </div>

          <Link 
            to="/forgot-username" 
            style={{ color: '#3498db', textDecoration: 'none', fontSize: '0.9rem' }}
          >
            Forgot your username?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;